import images from './images';

class MainCanvas {
  constructor({ width = 200, height = 200 } = {}) {
    this.canvas = document.createElement('canvas');

    this.canvas.width = width;
    this.canvas.height = height;

    this.width = width;
    this.height = height;

    this.context = this.canvas.getContext('2d');

    this.context.imageSmoothingEnabled = false;

    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;

    this.images = images;
  }

  reset(camera) {
    // reset canvas transform
    this.context.setTransform(1, 0, 0, 1, 0, 0);

    this.clear();

    this.applyCamera(camera);
  }

  applyCamera({ focus }) {
    this.translateX = -focus.x;
    this.translateY = -focus.y;
  }

  clear() {
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  }

  testRect(color) {
    this.context.fillStyle = color || '#000';

    this.context.fillRect(0, 0, 40, 20);
  }

  drawRect({ x, y, color, width = 30, height = 60 }) {
    this.context.fillStyle = color || '#000';

    this.context.fillRect(x, y, width, height);
  }

  drawCenteredRect({ x, y, color, width = 30, height = 60 }) {
    this.context.fillStyle = color || '#000';

    this.context.fillRect(
      x - (width / 2),
      y - (height / 2),
      width,
      height,
    );
  }

  drawThing(thing, frame = 0, row = 0, padX = 0) {
    if (thing.spriteName) thing.sprite = images[thing.spriteName];

    if (!thing.sprite) return;

    const spriteX = thing.x - (thing.width / 2);
    const spriteY = thing.y - (thing.height / 2);

    this.context.drawImage(
      thing.sprite,

      // sprite frame box
      (frame * thing.frameWidth) + (frame * padX),
      row * thing.frameHeight,
      thing.frameWidth,
      thing.frameHeight,

      // position in world
      spriteX, spriteY,

      // dimensions in world
      thing.width, thing.height,
    );
  }
}

export default MainCanvas;
